import React from 'react';
import TreatmentConsentLandingPage from './TreatmentConsentLandingPage';

export default function WisdomToothConsentFormUk() {
  return (
    <TreatmentConsentLandingPage
      title="Wisdom Tooth Consent Form UK | Surgical Extraction Consent | Smile Consent"
      description="Create a wisdom tooth consent form for UK practices with AI-assisted drafting, digital signing, and clearer records for nerve injury, swelling, infection, and aftercare."
      canonicalUrl="https://smileconsent.co.uk/wisdom-tooth-consent-form-uk"
      h1="Wisdom Tooth Consent Form for UK Practices"
      treatmentName="Wisdom tooth consent form"
      intro="Create wisdom tooth consent forms with clearer discussion of surgical risks, recovery, alternatives, and digital signing for UK dental practices."
      risks={[
        'Why wisdom tooth removal is recommended and the likely benefits of treatment.',
        'Material risks such as pain, swelling, bleeding, infection, dry socket, restricted mouth opening, and delayed healing.',
        'Specific surgical risks including nerve injury, sinus involvement, maxillary tuberosity fracture for upper 8s, damage to adjacent teeth, retained roots, or the need for referral where clinically relevant.',
        'Alternatives such as monitoring, referral, staged treatment, or no treatment where symptoms and findings allow.',
        'Recovery expectations, aftercare instructions, time away from normal activities, and follow-up planning.',
      ]}
      officialGuidanceLinks={[
        {
          title: 'NICE TA1 — guidance on the extraction of wisdom teeth',
          description:
            'National Institute for Health and Care Excellence technology appraisal: evidence-based recommendations for UK practice.',
          href: 'https://www.nice.org.uk/guidance/ta1',
          ctaLabel: 'Open on NICE',
        },
        {
          title: 'SDCEP — antibiotic prophylaxis against infective endocarditis',
          description:
            'Scottish Dental Clinical Effectiveness Programme implementation advice: who is at risk, which procedures may need discussion, shared decision-making, and prescribing principles (2nd edition updates).',
          href: 'https://www.antibioticprophylaxis.sdcep.org.uk/implementation-advice/introduction/main-changes-in-this-edition/',
          ctaLabel: 'Open SDCEP advice',
        },
      ]}
      relatedLinks={[
        {
          title: 'SDCEP: infective endocarditis prophylaxis',
          description: 'Official links and second-edition changes — read before relevant cases',
          path: '/sdcep-infective-endocarditis-prophylaxis',
        },
        { title: 'Tooth extraction consent form UK', description: 'Consent wording for routine and surgical extraction', path: '/tooth-extraction-consent-form-uk' },
        { title: 'Sedation consent form UK', description: 'Consent records for IV or inhalation sedation', path: '/sedation-consent-form-uk' },
        { title: 'AI dental consent forms', description: 'See all treatment-specific consent workflows', path: '/dental-consent-forms' },
      ]}
    />
  );
}
